<template>
  <BContainer class="p-0">
    <router-link v-if="order" :to="{name: 'ViewPointOfSale', params: {url: pos?.url ?? '/'}, query: backQuery}" class="back-btn text-white mb-3 d-block">
      <IconArrowLeft color="#ffffff" class="me-1"/> {{ $t('back') }}
    </router-link>
    <div v-if="order && pos && !saving">
      <div v-if="order">

        <gtm-page-view v-if="order && order.event && order.event.gtm_id && api_event_id" :gtm_id="order.event.gtm_id" :api_event_id="api_event_id"></gtm-page-view>

        <template v-if="timeslots && timeslots.length > 0">
          <h3>{{ $t('order_pick_timeslot') }}</h3>
          <BFormGroup>
            <BFormSelect v-model="timeslotId" :options="timeslots" value-field="id" text-field="label"></BFormSelect>
          </BFormGroup>
          <div class="text-right">
            <BButton variant="success" size="lg" class="mb-4" @click="processOrder()">
              {{ $t('order_continue') }}
            </BButton>
          </div>
        </template>
        <template v-if="openingHours.length > 0">
          <div class="content-block cart-container timeslot-header header-padding">
            <BRow>
              <BCol>
                <h1 class="mb-0">{{ $t('shop_timeslot') }}</h1>
                <label class="mb-0">{{ $t('pos_timeslot_choose_the_time') }}</label>
              </BCol>
              <BCol cols="3" class="d-flex align-items-center justify-content-end">
                <order-timer v-if="order" :order="order"></order-timer>
              </BCol>
            </BRow>
          </div>
          <div class="content-block cart-container timeslot-calendar">

            <vue-date-picker
                v-model="pickedDate"
                inline
                auto-apply
                :allowed-dates="enabledHours"
                :enable-time-picker="false"
            />

            <BFormGroup v-if="pickedDate" class="order-pick-timeslot" :label="$t('order_pick_timeslot')">
              <BRow id="timeslot-container timeslot-option">
                <BCol
                    v-for="option in timeOptions"
                    :key="option.day + option.opens_at"
                    class="mb-3"
                    lg="2"
                    md="4"
                    sm="6"
                >
                  <BButton
                      :variant="selectedOption === option ? 'success' : 'outline-secondary'"
                      :disabled="option.spots === 0 || (option.spots - option.spots_sold) < totalProductCount"
                      class="w-100"
                      @click="selectedOption = option"
                  >
                    {{ option.opens_at }} - {{ option.closes_at }}
                    <!-- ({{ option.spots_sold }} / {{ option.spots}}) -->
                  </BButton>
                </BCol>
              </BRow>
            </BFormGroup>
          </div>
        </template>

        <PosCartPlaceOrder :disabled="!selectedOption" @continue="makeTimeslotForSelectedOption()"/>
      </div>
    </div>
    <BRow v-else>
      <BCol class="text-center">
        <h1>{{ $t('order_loading') }}</h1>
        <BSpinner style="width: 10em; height: 10em;"></BSpinner>
      </BCol>
    </BRow>
  </BContainer>
</template>

<script>
import api from '../api'
import moment from 'moment'
import {mapState} from 'vuex'
import GtmPageView from '@/components/GtmPageView.vue'
import PosCartPlaceOrder from '@/components/PosCartPlaceOrder.vue';
import OrderTimer from '@/components/OrderTimer.vue';
import {
  BButton,
  BCol,
  BContainer,
  BFormGroup,
  BFormSelect,
  BRow,
  BSpinner
} from "bootstrap-vue-next";
import IconArrowLeft from "../components/icons/IconArrowLeft.vue";
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'

export default {
  name: 'OrderSelectTimeslot',
  components: {
    BButton,
    BContainer,
    BSpinner,
    BCol,
    BRow,
    BFormGroup,
    BFormSelect,
    OrderTimer,
    PosCartPlaceOrder,
    GtmPageView,
    IconArrowLeft,
    VueDatePicker
  },
  data() {
    return {
      saving: false,
      timeslots: [],
      timeslotId: null,
      openingHours: [],
      pickedDate: null,
      selectedOption: null,
      totalProductCount: null,
      calendarOptions: {
        startDate: null,
        endDate: null,
        disabledDate: [],
      },
      api_event_id: null
    }
  },
  methods: {
    makeTimeslotForSelectedOption(){
      if(this.order.payment_status === 'paid' || this.order.payment_status === 'pending') {
        this.$router.push({name: 'ViewPointOfSale', params: {url: this.pos.url}});
        this.$store.commit('errors', [this.$t('order_already_paid')]);
        return;
      }
      if(this.selectedOption){
        this.$store.commit('setCartTimeslot', this.selectedOption.day + ' ' + this.selectedOption.opens_at + ' - ' + this.selectedOption.closes_at)
      }
      if(!this.selectedOption.timeslot_id){
        api.openingHour().makeTimeslotForOrder(this.$route.params.id, this.$route.params.secret, this.selectedOption).then(timeslot => {
          this.timeslotId = timeslot.id
          this.processOrder()
        })
      } else {
        this.timeslotId = this.selectedOption.timeslot_id
        this.processOrder()
      }
    },
    processOrder() {
      this.saving = true
      let order = Object.assign(this.order, {timeslot_id: this.timeslotId})
      order.customer = null;
      if(order.payment_status === 'paid' || order.payment_status === 'pending') {
        this.$router.push({name: 'ViewPointOfSale', params: {url: this.pos.url}});
        this.$store.commit('errors', [this.$t('order_already_paid')]);
        return;
      }
      api.order().save(order).then((order) => {
        this.$store.commit('setOrder', order)
        if(this.campaign) {
          this.$router.push({name: 'OrderEnterPersonalDetails', params: this.$route.params, query: {ft_campaign_name: this.campaign.slug}})
        }
        else {
          this.$router.push({name: 'OrderEnterPersonalDetails', params: this.$route.params})
        }
      }).catch((error) => {
        if(error?.response?.data[0]?.code === 'order_already_paid') {
          this.$router.push({name: 'ViewPointOfSale', params: {url: this.pos.url}});
        }
        else {
          this.$store.commit('errors', ['error_try_again'])
        }
        this.saving = false
      })
    }
  },
  computed: {
    timeOptions(){
        if(!this.pickedDate) {
          return []
        }

        const date = moment(this.pickedDate).format('YYYY-MM-DD');

        return this.openingHours.filter((openingHour) => {
          return date === openingHour.day
        })
    },
    enabledHours() {
      return this.openingHours.map(oo => {
        return new Date(oo.day)
      })
    },
    backQuery() {
      if(this.campaign) {
        return {ft_campaign_name: this.campaign.slug, back: ''};
      }
      return {back: ''};
    },
    ...mapState(['cart', 'event', 'order', 'pos', 'campaign', 'company'])
  },
  created() {
    document.title = this.$t('pos_timeslot_title')
    this.api_event_id = 'ev_' + Date.now() + '_' + Math.floor(Math.random() * 100000);
    api.order().getBySecret(this.$route.params.id, this.$route.params.secret).then((order) => {
      this.$store.commit('setOrder', order)
      if(order && order.event && order.event.has_fb_capi && order.event.company_id && order.event.id) {
        api.facebookCAPI().pageView(order.event.company_id, order.event.id, this.api_event_id, window.location.pathname, document.title);
      }
    })

    let starts_at = moment().format('YYYY-MM-DD')
    let ends_at = moment().endOf('month').format('YYYY-MM-DD')

    api.openingHour().getByOrder(
        this.$route.params.id,
        this.$route.params.secret,
        starts_at,
        ends_at
    ).then(openingHours => {

      if(openingHours.length > 0 ) {
        this.openingHours = openingHours

        setTimeout(() => {
          const els = document.getElementsByClassName('timeslot-calendar')
          if(els.length > 0) {
            const cellInners = document.getElementsByClassName('dp__menu_inner')
            if(cellInners.length) {
              cellInners[0].style.width = (els[0].offsetWidth - 47 - 47) + 'px'; // 74 is the padding of the container
            }
          }
        }, 100)

        return
      }

      // Check if we have timeslots
      api.timeslot().getByOrder(this.$route.params.id, this.$route.params.secret).then((timeslots) => {
        if(this.timeslots.length === 0) {
          // also no timeslots, continue
          if(this.campaign) {
            this.$router.push({name: 'OrderEnterPersonalDetails', params: this.$route.params, query: {ft_campaign_name: this.campaign.slug}})
          }
          else {
            this.$router.push({name: 'OrderEnterPersonalDetails', params: this.$route.params})
          }
          return
        }
        this.timeslots = timeslots.map((timeslot) => {
          let start = moment(timeslot.starts_at)
          let end = moment(timeslot.ends_at)

          // Not same day, so print dates
          if (start.diff(end, 'days') !== 0) {
            timeslot.label = start.format('DD-MM HH:mm') + ' - ' + end.format('DD-MM HH:mm')
          } else {
            timeslot.label = start.format('HH:mm') + ' - ' + end.format('HH:mm')
          }

          return timeslot
        })
      })
    })

    if(this.cart){
      this.cart.products.forEach(p => {
        this.totalProductCount += p.amount
      })
    }

  }
}
</script>
<style>
.order-pick-timeslot{
  margin-bottom:0!important
}
.order-pick-timeslot > div{
  display:flex;
  align-items:center;
  gap:1rem;
}
.order-pick-timeslot .timeslot-option.custom-control{
  margin-bottom:0!important
}
@media(max-width:768px){
  .timeslot-calendar .b-calendar *{
    font-size:12px!important
  }
  .order-pick-timeslot > div b-label,.order-pick-timeslot .custom-control-label{
    font-size:12px
  }
}

.timeslot-calendar .dp__cell_inner {
  margin: auto;
}

@media(min-width:1000px) {
  .timeslot-calendar .dp__cell_inner {
    padding: 25px;
    border-radius: 25px;
  }
}
.timeslot-option.custom-control{
  padding-left:0px
}

</style>
<style scoped>
.header-padding{
  padding:35px!important
}

#timeslot-container{
  padding:0 15px
}

.timeslot-header {
  border-radius: 10px 10px 0 0 !important;
  padding:42px 47px!important
}
.timeslot-header h1 {
  color: #0A2336 !important;
  font-size: 32px !important;
  font-weight: bolder !important;
}

.timeslot-header label {
  color: #909090 !important;
  font-size: 16px !important;
  font-weight: bold !important;
}
.timeslot-calendar {
  border-radius:  0 0 10px 10px !important;
  margin-top: 1px !important;
}
@media (max-width:768px){
  .header-padding,.content-block,.timeslot-header{
    padding:20px!important
  }
  .timeslot-header h1 {
    font-size: 20px !important;
  }
  .timeslot-header label {
    font-size: 12px !important;
  }
}
</style>
